import {
  expaGetClientSideExpaFromCookie,
  expaGetClientSideFrozenExpaFromCookie,
  expaSetClientSideFrozenExpaCookie,
} from '../../expa'
import { COMPETERA_EXPERIMENT_CHANNEL } from '../../experiments/competera-experiment/consts'
import { experimentsCompeteraExperimentIsEnabledAndV1 } from '../../experiments/competera-experiment/experimentsCompeteraExperiment'
import { type ExperimentType } from '../../experiments/model/Experiment.types'

export const cartIntermediateFreezeExpaCookie = (
  experiments: ExperimentType[],
): void => {
  const expaCookie = expaGetClientSideExpaFromCookie()
  const frozenExpa = expaGetClientSideFrozenExpaFromCookie()
  let expaToSet = ''
  if (
    !expaCookie &&
    experimentsCompeteraExperimentIsEnabledAndV1(experiments)
  ) {
    expaToSet = COMPETERA_EXPERIMENT_CHANNEL
  } else if (expaCookie && !frozenExpa) {
    expaToSet = expaCookie
  }

  expaSetClientSideFrozenExpaCookie(expaToSet)
}
